import { render, staticRenderFns } from "./ContentVersionDetail.vue?vue&type=template&id=0b8a63e0&scoped=true&"
import script from "./ContentVersionDetail.vue?vue&type=script&lang=js&"
export * from "./ContentVersionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContentVersionDetail.vue?vue&type=style&index=0&id=0b8a63e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a63e0",
  null
  
)

export default component.exports